export const DESKTOP_SITE_PREFERENCE_KEY = 'use-desktop-site';

export const prefersDesktopSite = () => localStorage.getItem(DESKTOP_SITE_PREFERENCE_KEY) === 'true';

export const setDesktopSitePreference = (value: boolean) => {
  if (value) {
    localStorage.setItem(DESKTOP_SITE_PREFERENCE_KEY, 'true');
  } else {
    localStorage.removeItem(DESKTOP_SITE_PREFERENCE_KEY);
  }
};

export const clearDesktopSitePreference = () => localStorage.removeItem(DESKTOP_SITE_PREFERENCE_KEY);
